import { type Registry as Services, service } from '@ember/service';
import { assert } from '@ember/debug';
import { cached } from '@glimmer/tracking';
import EmberObject from '@ember/object';
import { camelize } from '@ember/string';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default abstract class BaseAbility<
  K extends keyof ModelRegistry,
> extends EmberObject {
  @service session!: Services['session'];

  model!: ModelRegistry[K];

  @cached
  get currentUser(): ModelRegistry['user'] {
    return this.session.currentUser as ModelRegistry['user'];
  }

  public getAbility(propertyName: string): boolean {
    const getter = this.#abilityGetter(propertyName);

    assert(
      `No ability getter found for '${this.constructor.name}.${getter}'`,
      !!(getter in this),
    );

    return this[getter];
  }

  protected isPermitted(permission: string): boolean {
    return this.currentUser.hasAccessTo(permission);
  }

  #abilityGetter(propertyName: string): string {
    return camelize(`can-${propertyName}`);
  }
}
